import React from "react";
import {useTranslation} from "react-i18next";
import helpers from "../../Utils/helpers";
import ExpandableTable from "../Fundamentals/Tables/ExpandedableTable";
import useSortingAndFiltering from "../../Hooks/useSortingAndFiltering";

const COLUMN_KEYS = {
    EVENT_DATE: "eventDate",
    EMAIL_ADDRESS: "emailAddress",
    EVENT: "event"
};

export const EmailDeliveryLogResults = ({ logs }) => {
    const {t} = useTranslation();
    
    const defaultComparer = (a, b) => {
        // Default sort by eventDate descending
        const aDate = new Date(a[COLUMN_KEYS.EVENT_DATE]).getTime();
        const bDate = new Date(b[COLUMN_KEYS.EVENT_DATE]).getTime();
        return bDate - aDate;
    };
    
    const { filteredAndSortedList, handleSortChange, getSortIcon } = useSortingAndFiltering({
        list: logs,
        searchText: "",
        searchableKeys: [COLUMN_KEYS.EMAIL_ADDRESS, COLUMN_KEYS.EVENT],
        defaultComparer
    });
    
    const renderHeader = (key, label) => (
        <th 
            onClick={() => handleSortChange(key)}
        >
            {label}{getSortIcon(key)}
        </th>
    );


    function renderField(label, value) {
        return (
            <div className="d-flex flex-row mb-8">
                <p className="col-2 mb-0 font-family-ubuntu-semibold">{label}</p>
                <p className="mb-0">{value}</p>
            </div>
        );
    }

    
    return (<ExpandableTable>
        <thead>
        <tr style={{ cursor: 'pointer', userSelect: 'none' }}>
            {renderHeader(COLUMN_KEYS.EVENT_DATE, t('activitylogtable.date'))}
            {renderHeader(COLUMN_KEYS.EVENT, t('activitylogtable.event'))}
            {renderHeader(COLUMN_KEYS.EMAIL_ADDRESS, t('activitylogtable.email'))}
        </tr>
        </thead>
        <ExpandableTable.Body>
            {filteredAndSortedList?.length > 0 ? (
                filteredAndSortedList?.map((log, index) => (
                    <ExpandableTable.Row key={index}>
                        <ExpandableTable.Row.Expandable>
                                <td>{helpers.formatDateAndTime(log.eventDate)}</td>
                            <td>{log.event}</td>
                                <td>{log.emailAddress}</td>
                        </ExpandableTable.Row.Expandable>
                        <ExpandableTable.Row.Expanded>
                            <tr>
                                <td colSpan={12} className="skynet-no-pointer-events">
                                    <div className="my-12">
                                        {renderField(t('activitylogtable.date'), `${helpers.formatDateAndTime(log.eventDate)}`)}
                                        {renderField(t('activitylogtable.email'), `${log.emailAddress}`)}
                                        {renderField(t('activitylogtable.event'), `${log.event}`)}
                                        {renderField(t('activitylogtable.ipaddress'), `${log.ip ?? ''}`)}
                                        {renderField(t('activitylogtable.tlsused'), `${log.tlsUsed ? t('activitylogtable.yes') : t('activitylogtable.no')}`)}
                                        {renderField(t('activitylogtable.certerror'), `${log.cert_Error ? t('activitylogtable.yes') : t('activitylogtable.no')}`)}
                                        {renderField(t('activitylogtable.status'), `${log.status ?? ''}`)}
                                        {renderField(t('activitylogtable.reason'), `${log.reason ?? ''}`)}
                                        {renderField(t('activitylogtable.type'), `${log.type ?? ''}`)}
                                        {renderField(t('activitylogtable.attempt'), `${log.attempt}`)}
                                        {renderField(t('activitylogtable.response'), `${log.response ?? ''}`)}
                                    </div>
                                </td>
                            </tr>
                        </ExpandableTable.Row.Expanded>
                    </ExpandableTable.Row>
                ))
            ) : (
                <tr>
                    <td colSpan={3}>{t('actionlogcontainer.noentriesfound')}</td>
                </tr>
            )}
        </ExpandableTable.Body>
    </ExpandableTable>)
}
